import MinimalDinheirowLogo from "@/assets/SVG/minimal_logo/dinheirow.svg";
import DinheirowLogo from "@/assets/SVG/logos/dinheirow-logo-white.svg";
import { IBrand } from "@/types/whitelabel";
import LoginImage from "@/assets/images/loginImage.png";
import { EMessageSendingType } from "@/constants/MessageSendingTypes";

const finalizedAnalysis = {
  title: "Parabéns!",
  description:
    "Sua análise foi aprovada!\n" +
    "Em caso de dúvida, não hesite em entrar em contato com um dos atendentes.",
};

const dinheirow: IBrand = {
  brand: "dinheirow",
  bankOrigin: "dinheirow",
  pageTitle: "Dinheirow",
  partnerCode: "partner_dinheirow",
  loanValues: {
    min: 300,
    max: 60000,
    cardValues: [5000, 10000, 20000, 30000, 50000],
  },
  contactEmail: "contato@dinheirow.com.br",
  contactWhatsappNumber: "",
  contactWhatsappMessage: "",
  colors: {
    primary: "#26CAD3",
    secondary: "#6A4F9B",
    tertiary: "#F3EA9B",
    quaternary: "#0071B9",
    success: "#1fb535",
    info: "#3267d1",
    alert: "#cfe622",
    error: "#e01d3a",
    quinary: "#7AD06D",
    grey: "#7A7A7A",
    "light-grey": "#F9F9F9",
    "primary-lighten": "#b7edf0",
    "tertiary-lighten": "#fdfbeb",
  },
  logoutUrl: "/",
  flowMessages: {
    maritalStatus: {
      title: "Informe o seu estado civil",
      description:
        "A informação correta do seu estado civil é muito importante para darmos mais agilidade ao seu pedido de empréstimo.",
    },
    naturalness: {
      title: "Informe o seu local de nascimento",
      description: "",
    },
    sameBankAccount: {
      title: "Deseja utilizar a mesma conta que está em seu contra-cheque/holerite?",
      description:
        "Você pode utilizar a mesma conta bancária que consta em seu Holerite (contra-cheque) ou cadastrar uma nova conta bancária para receber o seu financiamento.",
    },
    personalReferences: {
      title: "Informe uma referência pessoal",
      description: "",
    },
    person: {
      title: "Você é uma pessoa politicamente exposta?",
      description: "",
    },
    relationship: {
      title: "Você possui algum relacionamento próximo com uma pessoa politicamente exposta?",
      description: "",
    },
    addressConfirmation: {
      title: "Informações de endereço",
      description: "",
    },
    analysis: {
      title:
        "Iremos realizar a análise final da proposta e em até 1 dia útil, retomaremos com o status. Você poderá acompanhar a proposta por aqui ou pelo e-mail que enviaremos.",
      description: `
          Em caso de dúvidas não hesite em entrar em contato pelo e-mail
          <span class="font-weight-bold"> contato@dinheirow.com.br </span>
        `,
    },
    status_analise_finalizada: finalizedAnalysis,
    endorsement: {
      title: `Estamos mais perto do que nunca!`,
      description: `Parabéns! A proposta já foi encaminhada ao banco para a análise final. O prazo para o
          recebimento é em média de 2 dias úteis, podendo sofrer variações em função do banco
          parceiro e da disponibilidade do sistema do governo. Porém não se preocupe, estamos
          acompanhando todo o processo e entraremos em contato após a análise final pelo banco.`,
    },
    finalizedAnalysis: finalizedAnalysis,
    awaitTransfer: {
      title: "Empréstimo aprovado!",
      description: `Seu dinheiro será transferido em breve. Em caso de dúvidas não hesite em entrar em contato pelo e-mail <span class="font-weight-bold">contato@dinheirow.com.br</span>`,
    },
  },
  specificRoutes: [
    {
      path: "/",
      name: "Landing",
      meta: { requiresAuth: false },
      component: () => import("@/pages/landing/Landing.vue"),
      alias: ["/bancoarbi"],
    },
    {
      path: "/cadastro",
      name: "Register",
      meta: { requiresAuth: false },
      component: () => import("@/pages/register/RegisterPage.vue"),
      children: [
        {
          path: "dalla",
          name: "RegisterDalla",
          meta: { requiresAuth: false },
          props: { name: "Dalla" },
          component: () => import("@/components/register/Register.vue"),
        },
        {
          path: "arbi",
          name: "RegisterArbi",
          meta: { requiresAuth: false },
          props: { name: "Arbi" },
          component: () => import("@/components/register/Register.vue"),
        },
      ],
    },
    {
      path: "/blog",
      name: "Blog",
      beforeEnter: () => {
        window.location.href = "https://blog.dinheirow.com.br";
      },
    },
    {
      path: "/blog/*",
      name: "BlogRedirect",
      component: () => import("@/pages/blog_redirect/BlogRedirect.vue"),
    },
  ],
  modalityCodes: ["pensionista_inss", "militar", "servidor_municipal", "servidor_estadual"],
  hideWhatsappIcon: false,
  messageSendingType: EMessageSendingType.SMS,
  borrowerCanCreateProposal: true,
  borrowerCanCreateUser: true,
  additionalConfigs: {
    showProposalValues: true,
  },
  images: [
    {
      code: "headerImage",
      url: DinheirowLogo,
      height: "35px",
      width: "100px",
      src: DinheirowLogo,
      imageOccupation: "100",
    },
    {
      code: "headerImageMobile",
      url: MinimalDinheirowLogo,
      height: "100%",
      width: "50px",
      src: MinimalDinheirowLogo,
      imageOccupation: "100",
    },
    {
      code: "loginImage",
      height: "800px",
      imageOccupation: "100",
      src: LoginImage,
      url: LoginImage,
      width: "100%",
    },
    {
      code: "loginImageMobile",
      height: "100%",
      imageOccupation: "100",
      src: LoginImage,
      url: LoginImage,
      width: "100%",
    },
    {
      code: "createAccountImage",
      height: "600px",
      imageOccupation: "100",
      url: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1413&q=80",
      src: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1413&q=80",
      width: "100%",
    },
    {
      code: "createAccountImage",
      url: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1413&q=80",
      height: "0",
      width: "0",
      src: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1413&q=80",
    },
    {
      code: "registrationChoiceImage",
      height: "100%",
      imageOccupation: "100",
      src: "nodeAPI/brand/simonetti/files/2025-04-23T19-21-50_registrationChoiceImage.png",
      url: "https://dinheirow-stage.s3.us-east-1.amazonaws.com/nodeAPI/brand/simonetti/files/2025-04-23T19-21-50_registrationChoiceImage.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIA2CF523AM4SD2B4PJ%2F20250423%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250423T203610Z&X-Amz-Expires=86400&X-Amz-Signature=e5b3885a6abd0d72181d86630a203be6db26cc29d8707923e0493b40f787a207&X-Amz-SignedHeaders=host&x-id=GetObject",
      width: "100%",
    },
    {
      code: "registrationChoiceImageMobile",
      height: "100%",
      imageOccupation: "100",
      src: "nodeAPI/brand/simonetti/files/2025-04-23T19-22-21_registrationChoiceImageMobile.png",
      url: "https://dinheirow-stage.s3.us-east-1.amazonaws.com/nodeAPI/brand/simonetti/files/2025-04-23T19-22-21_registrationChoiceImageMobile.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIA2CF523AM4SD2B4PJ%2F20250423%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250423T203656Z&X-Amz-Expires=86400&X-Amz-Signature=d4d99902f6e38b567b78dd1dd8977d6d9ef6c7e4223fd0270118ef59cdf80a65&X-Amz-SignedHeaders=host&x-id=GetObject",
      width: "100%",
    },
  ],
};

export default dinheirow;
